document.addEventListener('DOMContentLoaded', function () {
    const submenuTriggers = document.querySelectorAll('.wiacc-show-submenu');

    submenuTriggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            this.setAttribute('aria-expanded', 'true');

            const targetClass = this.getAttribute('data-target');
            const delay = parseInt(this.getAttribute('data-timer')) || 0;

            setTimeout(() => {
                handleFocusTrap(trigger, targetClass);
                handleEscapeClose();
            }, delay);
        });
    });
});